import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-primary-50 py-12 px-4" }
const _hoisted_2 = { class: "max-w-2xl mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-8" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-heading font-bold text-primary-800 sm:text-3xl" }, " Join Foxwood Crossing "),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-primary-500" }, " Create your account in a few simple steps ")
], -1)
const _hoisted_4 = { class: "mb-8" }
const _hoisted_5 = { class: "grid grid-cols-1 overflow-hidden text-sm border border-primary-200 divide-x divide-primary-200 rounded-xl sm:grid-cols-3 bg-white" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<svg class=\"flex-shrink-0 mr-2 w-6 h-6\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2\"></path></svg><p class=\"leading-none\"><strong class=\"block font-medium\">Details</strong><small class=\"mt-1 text-xs opacity-75\">Your info</small></p>", 2)
const _hoisted_8 = [
  _hoisted_6
]
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<svg class=\"flex-shrink-0 mr-2 w-6 h-6\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z\"></path><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M15 11a3 3 0 11-6 0 3 3 0 016 0z\"></path></svg><p class=\"leading-none\"><strong class=\"block font-medium\">Address</strong><small class=\"mt-1 text-xs opacity-75\">Your home</small></p>", 2)
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<svg class=\"flex-shrink-0 mr-2 w-6 h-6\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg><p class=\"leading-none\"><strong class=\"block font-medium\">Confirm</strong><small class=\"mt-1 text-xs opacity-75\">Almost done!</small></p>", 2)
const _hoisted_13 = [
  _hoisted_11
]
const _hoisted_14 = { class: "bg-white rounded-xl border border-primary-200 shadow-card p-6 sm:p-8" }
const _hoisted_15 = { class: "text-center text-sm text-primary-500 mt-6" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Already have an account? ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Sign in ")

import { reactive, ref } from "vue";
import UserInfoForm from "@/components/register/UserInfoForm.vue";
import AddressForm from "@/components/register/AddressForm.vue";
import ConfirmRegistration from "@/components/register/ConfirmRegistration.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const detailsActive = ref(true);
const addressActive = ref(false);
const confirmActive = ref(false);
const createAccountObj = reactive({
  user: {} as RegistrationUser,
  house: {} as House,
});

const handleUserDetails = (user: {
  email: string;
  first_name: string;
  last_name: string;
}) => {
  createAccountObj.user = user;
  detailsActive.value = false;
  addressActive.value = true;
};

const handleAddress = (house: House) => {
  createAccountObj.house = house;
  addressActive.value = false;
  confirmActive.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ol", _hoisted_5, [
          _createElementVNode("li", {
            class: _normalizeClass(["flex items-center justify-center p-4 transition-colors", {
              'bg-accent-50 text-accent-700': detailsActive.value,
              'text-primary-500': !detailsActive.value,
            }])
          }, _hoisted_8, 2),
          _createElementVNode("li", {
            class: _normalizeClass(["relative flex items-center justify-center p-4 transition-colors", {
              'bg-accent-50 text-accent-700': addressActive.value,
              'text-primary-500': !addressActive.value,
            }])
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["absolute hidden w-4 h-4 rotate-45 -translate-y-1/2 border border-b-0 border-l-0 border-primary-200 sm:block -left-2 top-1/2", {
                'bg-accent-50': detailsActive.value,
                'bg-white': !detailsActive.value,
              }])
            }, null, 2),
            _createElementVNode("span", {
              class: _normalizeClass(["absolute hidden w-4 h-4 rotate-45 -translate-y-1/2 border border-b-0 border-l-0 border-primary-200 sm:block -right-2 top-1/2", {
                'bg-accent-50': addressActive.value,
                'bg-white': !addressActive.value,
              }])
            }, null, 2),
            _hoisted_9
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["flex items-center justify-center p-4 transition-colors", {
              'bg-accent-50 text-accent-700': confirmActive.value,
              'text-primary-500': !confirmActive.value,
            }])
          }, _hoisted_13, 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (detailsActive.value)
          ? (_openBlock(), _createBlock(UserInfoForm, {
              key: 0,
              onDetails_set: handleUserDetails
            }))
          : _createCommentVNode("", true),
        (addressActive.value)
          ? (_openBlock(), _createBlock(AddressForm, {
              key: 1,
              onAddressSet: handleAddress
            }))
          : _createCommentVNode("", true),
        (_unref(createAccountObj).house.house_number)
          ? (_openBlock(), _createBlock(ConfirmRegistration, {
              key: 2,
              "selected-house": _unref(createAccountObj).house,
              user: _unref(createAccountObj).user
            }, null, 8, ["selected-house", "user"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("p", _hoisted_15, [
        _hoisted_16,
        _createVNode(_component_router_link, {
          to: "/login",
          class: "text-accent-600 hover:text-accent-700 font-medium transition-colors"
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})